export default "__VITE_ASSET__BopSurDO__"